import type { FlexProps, HeadingProps } from '@chakra-ui/react';
import { Flex, Heading } from '@chakra-ui/react';
import React from 'react';

interface ISectionProps {
  children: React.ReactNode;
  containerProps?: FlexProps;
  headingProps?: HeadingProps;
  id: string;
  title?: string;
}

export const Section: React.FC<ISectionProps> = (props): JSX.Element => {
  const { children, id, title, headingProps = {}, containerProps = {} } = props;
  return (
    <Flex
      alignItems="center"
      direction="column"
      gap={{ base: 6, lg: 12 }}
      id={id}
      justifyContent="center"
      py={{ base: 2, md: 10 }}
      {...containerProps}
    >
      {title && (
        <Heading
          as="h1"
          fontSize={{ base: 'h1.base', md: 'h1.md' }}
          fontWeight="bold"
          mt="120px"
          textAlign="center"
          {...headingProps}
        >
          {title}
        </Heading>
      )}
      {children}
    </Flex>
  );
};

export const DocumentSection: React.FC<ISectionProps> = (props): JSX.Element => {
  const { children, id, title, headingProps = {}, containerProps = {} } = props;
  return (
    <Flex
      alignItems="center"
      direction="column"
      gap={{ base: 6, lg: 12 }}
      id={id}
      justifyContent="center"
      py={{ base: 2, md: 10 }}
      {...containerProps}
    >
      {title && (
        <Heading
          as="h1"
          display={{ base: 'none', md: 'block' }}
          fontSize={{ base: 'h1.base', md: 'h1.md' }}
          fontWeight="bold"
          mt="120px"
          textAlign="center"
          {...headingProps}
        >
          {title}
        </Heading>
      )}
      {children}
    </Flex>
  );
};
